export const data2_3 = [{
    name: '',
    name_code: "",
    Jan: "1",
    Feb: "1",
    Mar: "1",
    Apr: "1",
    May: "1",
    Jun: "1",
    Jul: "1",
    Aug: '1',
    Sep: "1",
    Oct: "1",
    Nov: "1",
    Dec: "1",
    whole: "1",
    nextJan: "1",
    nextFeb: "1",
    nextMar: "1",
    nextQ1: "1"
}, {
    name: 'Total Rooms Available 可供出租客房数',
    name_code: "Rooms_Available",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Total Rooms Occupied 实际入住客房数',
    name_code: "Rooms_Occupied",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Occupancy 平均出租率',
    name_code: "Occupancy%",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Average Room Rate 平均房价',
    name_code: "Average_Room_Rate",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'RevPAR 每间可供出租客房收入',
    name_code: "RevPAR",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Rooms Revenue 客房收入',
    name_code: "Rooms_Revenue",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'F&B Revenue 餐饮收入',
    name_code: "F&B_Revenue",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Other Operated Departments 其它营运部门收入',
    name_code: "Others_Revenue",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Total Dept. Revenue 总收入',
    name_code: "Total_Revenue",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: "Rooms Dept. Profit (Loss) 客房部门盈利（亏损）",
    name_code: "Rooms_Dep't_Income",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: "Rooms Dept. Profit % of Dept. Rev.<br/>客房部门盈利（亏损）占部门收入百分比 ",
    name_code: "Rooms_Dep't_Income_% ",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: "F&B Dept. Profit (Loss) 餐饮部门盈利（亏损）",
    name_code: "F&B_Dep't_Income",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: "F&B Dept. Profit % of Dept. Rev.<br/>餐饮部门盈利（亏损）占部门收入百分比",
    name_code: "F&B_Dep't_Income_% ",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Total Cost of Food and Beverage Sales 餐饮成本',
    name_code: "F&B_Total_Cost",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Total Cost of Food and Beverage Sales % of Dept. Rev. <br/>餐饮成本占部门收入百分比 ',
    name_code: "F&B_Total_Cost_%",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Total Dept. Labor Costs and Related Expenses <br/>所有部门总工资福利',
    name_code: "Total_Payroll_Cost",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Total Dept. Labor Costs and Related Expenses % of Total Dept. Rev.<br/>所有部门总工资福利占总收入百分比',
    name_code: "Total_Payroll_Cost_% ",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Utility Cost 能源成本',
    name_code: "Utility_Cost",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Utility Cost % of Total Dept. Rev. 能源成本占总收入百分比',
    name_code: "Utility_Cost_% ",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Other Expense and Cost 其他费用及成本',
    name_code: "Other_Expense_and_Cost",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Other Expense and Cost % 其他费用及成本率',
    name_code: "Other_Expense_and_Cost_%",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Gross Operating Profit (Loss) 总毛利润(亏损)',
    name_code: "GOP",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'GOP % of Total Rev. 总毛利润（亏损）占总收入百分比',
    name_code: "GOP_% ",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Breakeven Point 盈亏平衡点',
    name_code: "Breakeven_Point/Total_Exp",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Base Fee 基本管理费',
    name_code: "Base_Fee",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Brand Service Fee 品牌服务费',
    name_code: "Brand_Service_Fee",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Incentive Fee 奖励管理费',
    name_code: "Incentive_Fee",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Total Fee 总收费',
    name_code: "Total_Fee",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'Complimentary Room 免费房',
    name_code: "Complimentary_Room",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'House Use 自用用房',
    name_code: "House_Use",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'O-O-O Rooms 坏房',
    name_code: "O-O-O_Rooms",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}, {
    name: 'O-O-S Rooms 维护房',
    name_code: "O-O-S_Rooms",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: "0",
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    nextJan: "0",
    nextFeb: "0",
    nextMar: "0",
    nextQ1: "0"
}]


// WEBPACK FOOTER //
// ./src/components/table/2-Analysis/2-3/data.js